import { AssetPickerFileTypes } from './asset-picker-file-types.enum';

export const imageFileTypes = [AssetPickerFileTypes.Jpeg, AssetPickerFileTypes.Png];
